import {createAsyncThunk} from '@reduxjs/toolkit';
import {filtersApi} from 'api';
import {IEntityBase} from 'models';
import {toastNotificationManager} from 'toast-notifications';
import {prefix} from './config';

export const fetchLearningObjectivesThunk: any = createAsyncThunk<IEntityBase[]>(
  `${prefix} fetchLearningObjectives`,
  async (_, {rejectWithValue, dispatch}) => {
    try {
      const {parsedBody} = await filtersApi.getKLearningObjectives();
      return parsedBody;
    } catch (error) {
      dispatch(
        toastNotificationManager.createErrorToastAction(
          error.parsedBody || error.statusText || 'Failed to fetch learning objectives. Unknown error occurred.'
        )
      );
      return rejectWithValue(error);
    }
  }
);
